import { SCORE } from "../constants";

export interface ScoringState {
  score: number;
  combo: number;
  comboTimerSec: number;
  multiplierActive: boolean;
}

export function createScoring(): ScoringState {
  return { score: 0, combo: 1, comboTimerSec: 0, multiplierActive: false };
}

export function tickScoring(s: ScoringState, dtSec: number): void {
  // Passive survival score scales with current combo + multiplier.
  s.score += SCORE.PER_SECOND * dtSec * effectiveMultiplier(s);
  if (s.comboTimerSec > 0) {
    s.comboTimerSec = Math.max(0, s.comboTimerSec - dtSec);
    if (s.comboTimerSec === 0) s.combo = 1;
  }
}

export function rewardDodge(s: ScoringState): void {
  s.combo = Math.min(SCORE.COMBO_MAX, s.combo + SCORE.COMBO_STEP);
  s.comboTimerSec = SCORE.COMBO_RESET_SEC;
  s.score += SCORE.PER_DODGE * effectiveMultiplier(s);
}

export function rewardDestroy(s: ScoringState): void {
  s.score += SCORE.PER_DESTROY * effectiveMultiplier(s);
  s.combo = Math.min(SCORE.COMBO_MAX, s.combo + SCORE.COMBO_STEP);
  s.comboTimerSec = SCORE.COMBO_RESET_SEC;
}

export function effectiveMultiplier(s: ScoringState): number {
  return s.combo * (s.multiplierActive ? 2 : 1);
}
